import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LogOut, ShoppingBag, Home, AlertTriangle } from "lucide-react";
import { useAdminAuth } from "@/lib/adminAuth";
import { useAdminProducts } from "@/lib/adminProductsStore";
import { cn } from "@/lib/utils";
import { useEffect } from "react";

const navItems = [
  { to: "/admin/products", label: "Prodotti", icon: ShoppingBag },
];

export default function AdminLayout() {
  const { isAuthenticated, logout } = useAdminAuth();
  const { isDemo } = useAdminProducts();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) navigate("/admin");
  }, [isAuthenticated]);

  if (!isAuthenticated) return null;

  return (
    <div className="min-h-screen flex bg-stone-100">
      {/* Sidebar */}
      <aside className="w-60 bg-stone-950 flex flex-col shrink-0">
        <div className="px-6 py-7 border-b border-stone-800">
          <span className="font-bold text-xl tracking-[0.2em] text-white uppercase">
            Brupa
          </span>
          <p className="text-stone-600 text-[10px] tracking-widest uppercase mt-0.5">Admin</p>
        </div>

        <nav className="flex-1 px-3 py-4 space-y-1">
          {navItems.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                cn(
                  "flex items-center gap-3 px-3 py-2.5 text-xs tracking-widest uppercase transition-colors",
                  isActive
                    ? "bg-stone-800 text-white"
                    : "text-stone-500 hover:text-white hover:bg-stone-900"
                )
              }
            >
              <Icon className="size-4" />
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="px-3 py-4 border-t border-stone-800 space-y-1">
          <a
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 px-3 py-2.5 text-xs tracking-widest uppercase text-stone-500 hover:text-white hover:bg-stone-900 transition-colors"
          >
            <Home className="size-4" />
            Vedi sito
          </a>
          <button
            onClick={() => { logout(); navigate("/admin"); }}
            className="w-full flex items-center gap-3 px-3 py-2.5 text-xs tracking-widest uppercase text-stone-500 hover:text-red-400 hover:bg-stone-900 transition-colors"
          >
            <LogOut className="size-4" />
            Esci
          </button>
        </div>
      </aside>

      {/* Main */}
      <div className="flex-1 flex flex-col min-w-0">
        {/* Demo banner */}
        {isDemo && (
          <div className="bg-emerald-600 px-6 py-2.5 flex items-center gap-2">
            <AlertTriangle className="size-4 text-white shrink-0" />
            <p className="text-white text-xs">
              <strong>Modalità demo</strong> — I dati non vengono salvati. Configura Supabase con <code className="bg-emerald-700 px-1 rounded">VITE_SUPABASE_URL</code> e <code className="bg-emerald-700 px-1 rounded">VITE_SUPABASE_ANON_KEY</code> per abilitare il salvataggio.
            </p>
          </div>
        )}

        <main className="flex-1 p-8 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
